import { useState, useRef, useEffect } from 'react'
import { FaUserCircle, FaSignOutAlt } from 'react-icons/fa'
import { useMutation } from '@tanstack/react-query'
import { logoutUser } from '../api/authApi'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const UserDropdown = () => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const navigate = useNavigate()
  const { user, logout } = useAuth()

  // Use user data from context
  const userName = user?.fullName || 'User'
  const userRole = user?.role || 'User'

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const logoutMutation = useMutation({
    mutationFn: logoutUser,
    onSuccess: () => {
      logout() // Call context logout
      navigate('/login')
    },
  })

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex items-center gap-2 cursor-pointer p-2 hover:bg-orange-600 rounded-md transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center overflow-hidden">
          <FaUserCircle className="text-gray-600" size={26} />
        </div>
        <div className="hidden md:block text-white text-left">
          <p className="text-sm font-medium leading-tight">{userName}</p>
          <p className="text-xs opacity-80">{userRole}</p>
        </div>
      </div>
      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
          <div className="px-4 py-2 text-sm text-gray-700 border-b">
            <p className="font-medium">{userName}</p>
            <p className="text-xs text-gray-500">{userRole}</p>
          </div>
          <button
            onClick={() => logoutMutation.mutate()}
            className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            disabled={logoutMutation.isLoading}
          >
            <FaSignOutAlt className="mr-2" />
            {logoutMutation.isLoading ? 'Logging out...' : 'Logout'}
          </button>
        </div>
      )}
    </div>
  )
}

export default UserDropdown
